<template>  
  <div :id="'photo-card-'+photo.id" class='photo-card contentBackground' v-if="!photo.hidden" :data-attendee-id='eventAttendee.id'>

    <div class='header-content-container'>
      <div class='photo-card-overlay' v-if="this.canManage">
        <div v-if='fetchingApproveStatus'>
          <i class='fa fa-spinner fa-spin fa-2x text-white'></i>
        </div>
        <div class="post-btn">
          <div class='approve-post-btn mr-3' v-if="!photo.approved && !fetchingApproveStatus" @click="approvePhoto()">
          Approve Post
        </div>
        <div class='delete-post-btn' ref='showModalBtn' @click="openModal()" v-if="!fetchingApproveStatus">
          <i class="far fa-eye-slash"></i>
        </div>
        </div>
        <photo-stream-modal-legacy
          v-if='showModal'
          v-on:close="closeModal"
        >
          <template #header>
            <div class='title'>
              Hide Post
            </div>
          </template>
          <template #body>
            <div class="row">
              <div class="col-sm-12">Are you sure you want to permanently hide this Post?</div>
            </div>
            <br>
            <div>
              <button type="button" class="btn modal-close btn-danger mr-2" v-on:click="closeModal">Cancel</button>
              <button type="button" class="btn modal-close btn-success mr-2" v-on:click="denyPhoto">Hide</button>
            </div>
          </template>

        </photo-stream-modal-legacy>
      </div>

      <div class='photo-header'>
        <div class='pending-approval-banner' v-if="this.requiresApproval && !this.photo.approved">
          pending approval
        </div>
        <div class='main-photo-header'>
          <div v-if="userAvatarUrl">
            <img class='initials' :src="userAvatarUrl">
          </div>
          <div class='initials' v-if="!userAvatarUrl">
            {{initials}}
          </div>
          <div class='title-container'>
            <div class='name'>{{ attendeeName }}</div>
            <div class='time-since'>{{ createdFromNow() }}</div>
          </div>
        </div>
      </div>

      <div class='photo-content' v-if='hasContent'>
        <img ref='img' :src="photo.photo_url" class='photo-content-image' v-if="isImage" />
        <!-- <img ref='img' :src="photo.photo_url.replace(/^https:\/\//i, 'http://')" class='photo-content-image' v-if="isImage" /> -->
        <video v-if="isVideo" height="auto" width="100%" controls="controls">
          <!-- <source :src="photo.photo_url.replace(/^https:\/\//i, 'http://')"> -->
          <source :src="photo.photo_url">
        </video>
      </div>

    </div>

    <div class='photo-footer'>
      <div class='photo-post' v-html="this.urlifyCaption">
      </div>

      <div class='user-tags-row themePrimaryColor' v-if="photo.tagged_attendee_names && photo.tagged_attendee_names.length">
        <span class='badge themePrimaryColor' v-for="(taggedAttendee, i) in photo.tagged_attendee_names" :key="i">
          {{`${taggedAttendee.first_name} ${taggedAttendee.last_name}`}}
        </span>
      </div>

      <div class='comment-like-row themePrimaryColor'>
        
        <div class='comment-count' @click="toggleComments()">
          <span v-if="this.hasComments">
            {{ (photo.comments.length> 1)? lang.get('event_strings.photo_stream.comment_plural_js').replace("{AMOUNT}",photo.comments.length):lang.get('event_strings.photo_stream.comment_single_js').replace("{AMOUNT}",photo.comments.length) }}
          </span>
        </div>

        <div class='likes-count-container' @click='toggleLike()'>
          <span v-if="this.hasLikes" class='likes-count'>
            {{ (photo.likes.length > 1)? lang.get('event_strings.photo_stream.like_plural_js').replace("{AMOUNT}",photo.likes.length):lang.get('event_strings.photo_stream.likes_single_js').replace("{AMOUNT}",photo.likes.length) }}
          </span>
          <i v-show="this.iLiked" class="fas fa-2x fa-heart"></i>
          <i v-show="!this.iLiked" class="fal fa-2x fa-heart"></i>
        </div>
      </div> 

      <div class='photo-stream-comments' v-if="this.commentsVisible">
        <photo-stream-comment
          v-for='comment in this.photo.comments' 
          :key="comment.id"
          v-bind:comment="comment"
        >
        </photo-stream-comment>
      </div>

    </div>

    <div class='new-comment-form'>
      <input type='text' class='new-comment-input' ref='comment' :placeholder=" lang.get('event_strings.photo_stream.add_comment')">
      <div 
        tabindex="0" 
        class='new-comment-submit' 
        v-on:keyup.enter="handleSubmitComment"
        @click="handleSubmitComment()"
      >
        {{ lang.get('event_strings.photo_stream.post_text') }}
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios';
export default {
  // name: "attendees-modal",
  props: ["eventId", 'streamId', 'manage', 'apiAuthToken', 'photo', 'eventAttendee', 'canManage', 'requiresApproval', 'baseUrl', 'isWeb'],

  data () {
    return {
      commentsVisible: false,
      fetchingApproveStatus: false,
      showModal: false,
    }
  },

  computed: {

    urlifyCaption () {

      function removeTags(str) {
          if ((str===null) || (str===''))
          return false;
          else
          str = str.toString();
          return str.replace( /(<([^>]+)>)/ig, '');
      }

      var caption = removeTags(this.photo.photo_caption)
      if (!caption) caption = ''

      var urlRegex = /(https?:\/\/[^\s]+)/g;
        return caption.replace(urlRegex, function(url) {
          return '<a target=_blank href="' + url + '">' + url + '</a>';
        })
    },

    myLike () {
      if (!this.photo.likes || !this.photo.likes.length) return false
      return this.photo.likes.find((like) => like.event_attendee_id === this.eventAttendee.id)
    },

    iLiked () {
      return !!this.myLike
    },

    hasLikes () {
      return this.photo.likes && this.photo.likes.length > 0
    },

    hasComments () {
      return this.photo.comments && this.photo.comments.length > 0
    },

    attendeeName () {
      return this.photo.attendee_name
    },

    hasContent () {
      return this.photo.photo_url
    },

    isImage () {
      return this.photo.photo_content_type
        && this.photo.photo_content_type.includes('image')
    },

    isVideo () {
      return this.photo.photo_content_type
        && this.photo.photo_content_type.includes('video')
    },

    initials () {
      var attendeeFields = this.photo.event_attendee && this.photo.event_attendee.attendee_fields 
      if (!attendeeFields) return
      if (attendeeFields.first_name && attendeeFields.last_name) {
        return `${attendeeFields.first_name[0]} ${attendeeFields.last_name[0]}`
      }
    },

    userAvatarUrl () {
      var attendeeFields = this.photo.event_attendee && this.photo.event_attendee.attendee_fields 
      if (!attendeeFields) return
      if (attendeeFields.user_avatar_url) {
        return `${attendeeFields.user_avatar_url}`
      }
    },

    momentCreatedAt () {
      return new moment.utc(this.photo.created_at)
    }

  },

  methods: {

    closeModal () {
      this.showModal = false
    },

    openModal () {
      this.showModal = true
    },

    toggleLike () {
      this.iLiked 
        ? this.$emit('unlike', this.photo, this.myLike) 
        : this.$emit('like', this.photo)
    },

    emitApprovedPhoto () {
      this.$emit('approved-photo', this.photo)
    },
    
    emitDeniedPhoto () {
      this.$emit('deny-photo', this.photo)
    },

    approvePhoto () {
      this.fetchingApproveStatus = true

      var url = this.getFormattedURL(`/photo-streams/${this.streamId}/photos/${this.photo.id}/approve`);

      axios.post(url, {
        api_auth_token: this.apiAuthToken
      }).then((res) => {
        if (res.data && res.data.data) {
          this.$emit('approved-photo', res.data.data)
        } else {
          throw error('no approval returned')
        }
      }).catch((err) => {
        Vue.toasted.show('error approving post', {
          type: 'error', 
          duration: 4000,
          position: 'bottom-right',
          action: {
            text: 'DISMISS',
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }            
          }}
        );
      }).finally(() => {
        this.fetchingApproveStatus = false
      })
    },

    denyPhoto () {
      self = this
      var url = this.getFormattedURL(`/photo-streams/${this.streamId}/photos/${this.photo.id}/approve/1`);
      axios.post(url, {
        _method: "delete",
        api_auth_token: this.apiAuthToken
      }).then((res) => {
        self.closeModal()
        if (res.data && res.data.data) {
          self.$emit('denied-photo', res.data.data)
        } else {
          throw error('no data returned')
        }
      }).catch((err) => {
        Vue.toasted.show('error un-approving post', {
          type: 'error', 
          duration: 4000,
          position: 'bottom-right',
          action: {
            text: 'DISMISS',
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }            
          }}
        );
      })
    },    

    handleSubmitComment () {
      const commentText = this.$refs.comment.value
      if (commentText.length === 0) {
        return
      }

      this.$emit('comment', this.photo, commentText)

      this.$refs.comment.value = ''
      this.commentsVisible = true
    },

    shouldShowComments () {
      return this.commentsVisible && this.photo.comments.length
    },

    createdFromNow () {
      console.log('time',this.momentCreatedAt.fromNow())
      return this.momentCreatedAt.fromNow()
    },

    toggleComments () {
      return this.commentsVisible = !this.commentsVisible
    },

    updatePhotoCardForTImeSince () {
      window.setTimeout(() => {
        this.$forceUpdate()
        this.updatePhotoCardForTImeSince()
      }, 10000)
    },

    getFormattedURL(relativePath) {
      var url = relativePath

      if(this.isWeb != 'true') {
        url = `/events/${this.eventId}`+url
      }

      if ((typeof this.baseUrl === 'string' || this.baseUrl instanceof String) && this.baseUrl != '') {
        url = this.baseUrl+url
      }

      return url
    },  
  },

  mounted: function () {
    this.updatePhotoCardForTImeSince()
    if (!this.$refs.img) return
    this.$refs.img.onerror = function () {
      this.onerror = ''
      this.src = "/assets/placeholder_broken_image.png";  
    }
  }
};

</script>

<style scoped>
  .photo-card {
    position: relative;
    width: 100%;
    margin-top: 2rem;
    margin-bottom: 2rem;
    -webkit-box-shadow: 10px 10px 9px -8px rgba(156,156,156,0.75);
    -moz-box-shadow: 10px 10px 9px -8px rgba(156,156,156,0.75);
    box-shadow: 10px 10px 9px -8px rgba(156,156,156,0.75);
  }

  .header-content-container {
    position: relative;
  }

  .header-content-container .photo-card-overlay {
    transition: ease-out 0.2s;
  }

  .photo-card:hover .header-content-container .photo-card-overlay {
    bottom: 0;
    height: 100%;
    transition: ease-in-out 0.2s;
  }

  .photo-card-overlay {
    position: absolute;
    bottom: 100%;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    overflow: hidden;
    width: 100%;
    height: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .photo-card-overlay > * {
    margin: 2rem;
  }

  .approve-post-btn {
    padding: 0.6rem 2rem;
    border-radius: 80px;
    border: 2px solid #ffffff;
    color: #ffffff;
    background-color: rgba(0,0,0,0%);
    cursor: pointer;
    z-index: 100;
  }

  .delete-post-btn {
    padding: 2rem;
    border-radius: 100%;
    border: 2px solid #ffffff;
    color: #ffffff;
    background-color: rgba(0,0,0,0%);
    cursor: pointer;
    z-index: 100;
  }

  .delete-post-btn:hover, .approve-post-btn:hover {
    background-color: rgba(0,0,0,20%);
  }

  .photo-header {
    display: flex;
    flex-direction: column;
  }

  .pending-approval-banner {
    display: flex;
    justify-content: center;
    background-color: red;
    color: #fff
  }

  .main-photo-header {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .main-photo-header > * {
    margin: 2rem;
  }

  .photo-content-image {
    width: 100%;
    object-fit: contain;
  }

  .photo-footer {
    padding: 2rem;
  }

  .photo-post {
    white-space: pre-line;
  }

  .title-container {
    display: flex;
    flex-direction: column;
  }

  .comment-like-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-weight: bold;
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
  }

  .user-tags-row {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    font-size: 1.3rem;
    font-weight: bold;
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
  }  

  .user-tags-row > * {
    margin-right: 0.4rem
  }

  .new-comment-form {
    display: flex;
    border-top: 0.2px solid rgba(232, 236, 241, 60%);
  }

  .new-comment-input {
  flex: 1;
  padding-left: 2rem;
  border: none;
  background-color: var(--theme-content-bg-color);
}

.new-comment-input {
  flex: 1;
  padding: 1.5rem;
  padding-left: 2rem;
  border: none;
  background-color: var(--theme-content-bg-color);
}

.new-comment-submit {
  padding: 1.5rem;
  padding-right: 2rem;
}

.likes-count-container {
  display: flex;
  justify-content: center;
  align-items: center;    
}

.likes-count {
  font-weight: bold;
  padding-right: 0.4rem;
}

.comment-count {
  display: flex;
  align-items: center;
}

video {
  max-height: 70vh;
}

.post-btn {
  display: flex;
  align-items: center;
}

</style>

